import { Link } from "react-router-dom";

const Error = () => {
  return (
    <section className="error">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/*start error-content */}
            <div className="error-content">
              <h2>404 Error</h2>
              <p>Oops! Page Not Found</p>
              {/* <form action="#">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search again..."
                  />
                  <div className="input-search">
                    <a href="#">
                      {" "}
                      <i className="ti-search" />
                    </a>
                  </div>
                </div>
              </form> */}
              <div className="error-content-link mt-5">
                <Link to="/">
                  <i className="ti-arrow-left" />
                  back to home
                </Link>
              </div>
            </div>
            {/*end error-content */}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Error;